import { ReactComponent as Magnifier } from "./magnifier.svg";
import { ReactComponent as Jump } from "./jump.svg";
import { ReactComponent as Loading } from "./loading.svg"

export const MagnifierCharacter = () => <Magnifier />;
export const JumpCharacter = () => <Jump />;
export const LoadingCharacter = () => <Loading />;
